// src/pages/Contact/ContactPage.js
import { useState } from 'react';
import './ContactPage.css';

import { useDocumentTitle } from '../../hooks/useDocumentTitle';
export default function ContactPage() {
  useDocumentTitle('Contact');

  const [form, setForm] = useState({ nom: '', email: '', objet: '', message: '' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [apiError, setApiError] = useState('');

  function validate() {
    const e = {};
    if (!form.nom.trim()) e.nom = 'Le nom est requis.';
    if (!form.email.trim()) e.email = "L'email est requis.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = 'Email invalide.';
    if (!form.objet.trim()) e.objet = "L'objet est requis.";
    if (!form.message.trim()) e.message = 'Le message est requis.';
    else if (form.message.trim().length < 10) e.message = 'Le message doit contenir au moins 10 caracteres.';
    return e;
  }

  function handleChange(e) {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
    if (errors[name]) setErrors(er => ({ ...er, [name]: '' }));
    setApiError('');
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setSuccess('');
    setApiError('');
    const errs = validate();
    if (Object.keys(errs).length > 0) { setErrors(errs); return; }

    setLoading(true);
    try {
      const API = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
      const res = await fetch(`${API}/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Erreur lors de l\'envoi.');
      setSuccess(data.message);
      setForm({ nom: '', email: '', objet: '', message: '' });
    } catch (err) {
      setApiError(err.message);
    } finally {
      setLoading(false);
    }
  }

  const fields = [
    { name: 'nom',   label: 'Votre nom',    type: 'text',  placeholder: 'Prenom Nom' },
    { name: 'email', label: 'Votre email',   type: 'email', placeholder: 'votre@email.com' },
    { name: 'objet', label: 'Objet',         type: 'text',  placeholder: 'Sujet de votre message' },
  ];

  return (
    <div className="contact-page">
      <div className="container contact-page__inner">
        <p className="contact-page__overtitle">Nous contacter</p>
        <h1 className="contact-page__titre">Une question ?</h1>
        <hr className="divider-or" style={{ margin: '16px 0 12px', marginLeft: 0 }} />
        <p className="contact-page__sous">
          Notre equipe vous repond sous 24 heures. Vous pouvez aussi nous retrouver sur{' '}
          <a href="https://tiktok.com/@les_bazars_de_keassa" target="_blank" rel="noreferrer" className="contact-page__link">TikTok</a> et{' '}
          <a href="https://instagram.com/les_bazars_de_keassa" target="_blank" rel="noreferrer" className="contact-page__link">Instagram</a>.
        </p>

        {success && (
          <div className="contact-page__success" role="status">
            <span>✓</span> {success}
          </div>
        )}

        {apiError && (
          <div className="contact-page__error" role="alert">
            <span>!</span> {apiError}
          </div>
        )}

        {!success && (
          <form onSubmit={handleSubmit} className="contact-form" noValidate>
            {fields.map(f => (
              <div key={f.name} className="contact-field">
                <label htmlFor={f.name} className="contact-label">{f.label} *</label>
                <input
                  id={f.name} name={f.name} type={f.type}
                  className={`contact-input${errors[f.name] ? ' contact-input--error' : ''}`}
                  placeholder={f.placeholder}
                  value={form[f.name]}
                  onChange={handleChange}
                  required
                />
                {errors[f.name] && <p className="contact-field-error">{errors[f.name]}</p>}
              </div>
            ))}

            <div className="contact-field">
              <label htmlFor="message" className="contact-label">Message *</label>
              <textarea
                id="message" name="message" rows={6}
                className={`contact-input contact-textarea${errors.message ? ' contact-input--error' : ''}`}
                placeholder="Votre message (10 caracteres minimum)..."
                value={form.message}
                onChange={handleChange}
                required
              />
              {errors.message && <p className="contact-field-error">{errors.message}</p>}
              <p className="contact-field-count">{form.message.length} caractere{form.message.length > 1 ? 's' : ''}</p>
            </div>

            <button
              type="submit"
              className={`btn-or contact-submit${loading ? ' contact-submit--loading' : ''}`}
              disabled={loading}
            >
              {loading ? 'Envoi en cours...' : 'Envoyer le message'}
            </button>
          </form>
        )}

        <div className="contact-info">
          <div className="contact-info__item">
            <span className="contact-info__icon">📍</span>
            <div>
              <p className="contact-info__label">Adresse</p>
              <p className="contact-info__value">Paris, France</p>
            </div>
          </div>
          <div className="contact-info__item">
            <span className="contact-info__icon">📧</span>
            <div>
              <p className="contact-info__label">Email</p>
              <p className="contact-info__value">contact@lesbazarsdekeassa.com</p>
            </div>
          </div>
          <div className="contact-info__item">
            <span className="contact-info__icon">📱</span>
            <div>
              <p className="contact-info__label">Reseaux sociaux</p>
              <p className="contact-info__value">
                <a href="https://tiktok.com/@les_bazars_de_keassa" target="_blank" rel="noreferrer" className="contact-page__link">TikTok</a>
                {' · '}
                <a href="https://instagram.com/les_bazars_de_keassa" target="_blank" rel="noreferrer" className="contact-page__link">Instagram</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}